export default theme => ({
  blockContainer: {
    height: '100%',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '1400px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      backgroundImage: 'none !important',
      backgroundColor: theme.palette.yellow.main,
      position: 'relative',
      height: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  content: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    maxWidth: '100%',
    height: '100%',
    width: '100%',
  },
  main: {
    position: 'absolute',
    top: '50%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    color: theme.palette.blue.dark,
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 64px)',
      left: 32,
      transform: 'translate(0, -50%)',
    },
  },
  title: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(1),
  },
  text: {
    paddingBottom: theme.spacing(4),
  },
  logo: {
    position: 'absolute',
    top: '5%',
    left: '10%',
    width: '10%',
    maxWidth: 150,
    [theme.breakpoints.down('md')]: {
      left: theme.spacing(4),
      top: theme.spacing(8),
    },
  },
  btn: {
    position: 'absolute',
    bottom: '10%',
    left: '10%',
    [theme.breakpoints.down('md')]: {
      left: theme.spacing(4),
      bottom: theme.spacing(4),
    },
  },
});
